import React from "react";
import styled from "styled-components";

const Button = styled.button`
  background-color: ${props =>
    props.outlined ? "transparent" : props.theme.primary};
  color: ${props => (props.outlined ? props.theme.text : props.theme.white)};

  border: 1px solid ${props => props.theme.primary};
  border-radius: 33px;
  cursor: pointer;
  outline: none;
  width: 100%;
  height: 100%;

  @media (min-width: 1800px) {
    border-width: 2px;
  }
`;

export default Button;
